import React, { useRef, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import heroBg from "../../../assets/new_homes/new-home-banner.jpg";
import SearchBar from "./SearchBar";
import CategoryTabs from "./CategoryTabs";
import { tabHeadings, nigeriaStates } from "../data/mockData";

const HeroSection = ({ activeTab, setActiveTab }) => {
  const [selectedState, setSelectedState] = useState("Lagos");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const heading = tabHeadings[activeTab];

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <section
      className="relative w-full min-h-[416px] md:min-h-[416px] flex flex-col justify-center bg-center bg-no-repeat gap-6"
      style={{ backgroundImage: `url(${heroBg})`, backgroundSize: "cover" }}
      aria-label="New apartments hero section"
    >
      <div className="absolute inset-0 bg-black bg-opacity-50" aria-hidden="true" />

      <div className="relative  z-10 w-full container py-8 flex flex-col gap-4">
        <nav aria-label="Breadcrumb" className="flex items-center gap-3 text-white text-sm opacity-90">
          <Link to="/new-homes" >New Homes</Link>
          <span className="opacity-60">/</span>
          <span>New Apartments</span>
          <span className="opacity-60">/</span>
          <span className="flex items-center gap-1">
            <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
              <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
            </svg>
            {selectedState}
          </span>
        </nav>

        <h1 className="text-white leading-tight py-3">
          {heading.title ? (
            <span className={activeTab === "Explore" ? "text-3xl md:text-5xl font-bold" : "text-2xl md:text-4xl font-semibold"}>
              {heading.title}
            </span>
          ) : (
            <span className="text-2xl md:text-4xl font-semibold inline-flex items-center flex-wrap gap-1">
              {heading.prefix}{" "}
              <span className="font-bold">{selectedState}</span>
              {heading.showDropdown && (
                <div className="relative inline-block" ref={dropdownRef}>
                  <button
                    onClick={() => setDropdownOpen((o) => !o)}
                    className="inline-flex items-center text-white hover:text-gray-200 focus:outline-none focus:ring-2 focus:ring-white rounded align-middle ml-1"
                    aria-label="Change state"
                    aria-expanded={dropdownOpen}
                    aria-haspopup="listbox"
                  >
                    <svg
                      className={`w-5 h-5 transition-transform duration-200 ${dropdownOpen ? "rotate-180" : ""}`}
                      fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>

                  {dropdownOpen && (
                    <ul
                      role="listbox"
                      aria-label="Select state"
                      className="absolute left-0 top-full mt-2 w-52 bg-white rounded-md shadow-xl z-50 max-h-72 overflow-y-auto py-1"
                    >
                      {nigeriaStates.map((state) => (
                        <li
                          key={state}
                          role="option"
                          aria-selected={selectedState === state}
                          onClick={() => { setSelectedState(state); setDropdownOpen(false); }}
                          className={`px-4 py-2.5 text-sm cursor-pointer transition-colors duration-100 ${selectedState === state
                            ? "text-blue-600 font-semibold bg-blue-50"
                            : "text-gray-700 hover:bg-gray-50"
                            }`}
                        >
                          {state}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              )}
            </span>
          )}
        </h1>

        {heading.subtitle && (
          <p className="text-blue-300 text-sm md:text-base">{heading.subtitle}</p>
        )}

        <div>
          <CategoryTabs activeTab={activeTab} setActiveTab={setActiveTab} />
        </div>

        {activeTab !== "Explore" && (
          <SearchBar />
        )}
      </div>
    </section>
  );
};

export default HeroSection;
